import React from "react";

/** Highlighted box wrapping an inline record edit form. */
const RecordEditShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="tw-border tw-border-primary/30 tw-rounded-md tw-p-3 tw-space-y-2 tw-bg-primary/5">
    {children}
  </div>
);

export default RecordEditShell;
